45/* Layout */
//
const Layout = () => import("@/layout")

import Vue from "vue"
import Router from "vue-router"

Vue.use(Router)

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
 roles: ['admin','editor']    control the page roles (you can set multiple roles)
 title: 'title'               the name show in sidebar and breadcrumb (recommend set)
 icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
 breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
 activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
 }
 */

import BusinessRouter from "@/router/BusinessRouter"

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: "/dc/admin/setting",
    component: () => import("@/views/frame/page/setting/index"),
    meta: { title: "系统设置", icon: "dashboard" },
    hidden: true
  }, {
    path: "/dc/admin/login",
    component: () => import("@/views/frame/page/login/index"),
    meta: { title: "用户登录", icon: "dashboard" },
    hidden: true
  }, {
    path: "/dc/admin/skip",
    component: () => import("@/views/frame/page/skip"),
    meta: { title: "跳转中", icon: "dashboard" },
    hidden: true
  }, {
    path: "/404",
    component: () => import("@/views/frame/page/error/404"),
    meta: { title: "404 - 页面未找到", icon: "dashboard" },
    hidden: true
  },

  // ====================  layout布局的界面  ====================
  {
    path: "/",
    component: Layout,
    redirect: "/base/home",
    children: [// ====================  基础界面 - 主页  ====================
      {
        path: "/base/home",
        component: () => import("@/views/frame/page/home"),
        meta: { title: "系统首页", icon: "dashboard" }
      }, // ====================  基础界面 - 示例界面  ====================
      {
        path: "demo/list",
        name: "list",
        component: () => import("@/views/demo/list"),
        meta: { title: "列表页示例", icon: "dashboard" },
        hidden: true
      }, {
        path: "/demo/info",
        name: "info",
        component: () => import("@/views/demo/info"),
        meta: { title: "信息页页示例", icon: "dashboard" },
        hidden: true
      }, {
        path: "/demo/report",
        name: "report",
        component: () => import("@/views/demo/report"),
        meta: { title: "报表页示例", icon: "dashboard" },
        hidden: true
      }, {
        path: "/demo/board",
        name: "board",
        component: () => import("@/views/demo/board"),
        meta: { title: "看板页示例", icon: "dashboard" },
        hidden: true
      }, { ...BusinessRouter } //  ====================  门店管理 - 门店字典 - 库存管理  ====================
    ]
  } // ====================  大屏看板界面  ====================

  // 404页，*统配，必须设置在最后
  // { path: "*", redirect: "/404", hidden: true }
]

const createRouter = () => new Router({
  scrollBehavior: () => ({ y: 0 }), routes: constantRoutes
})

// 创建路由
const router = createRouter()

// 重设路由
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router
